<template>
  <div v-if="isVisibile">
    <span v-if="percentPill" class="Price__Pill">
      <span class="t5">{{ percentPill }}</span>
    </span>
    <span v-if="isTiered" class="Price__Pill">
      <span class="t5">{{ tieredPillMessage }}</span>
    </span>
    <!--
        <span v-for="pill in pills" :key="pill" class="Price__Pill">
          <span class="t5">{{ pill }}</span>
        </span>
      -->
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { parseTag } from '@utils/format';

const props = defineProps({
  tags: {
    type: Array,
    required: true,
    default: [],
  },
  ready: {
    type: Boolean,
    default: true,
  },
  promo: {
    type: Object,
    required: true,
    default: {},
  },
  location: {
    type: String,
    required: true,
    default: '',
  },
  promotedOptionGroups: {
    type: Object,
    default: {},
  },
  defaultPrice: {
    type: Number,
  },
  discountedPrice: {
    type: Number,
  },
});

const percentPill = computed(() => {
  let percentOffMessage = `${Math.floor(100 - (props?.discountedPrice / props?.defaultPrice) * 100)}% off`;
  return props?.discountedPrice / props?.defaultPrice < 1 ? percentOffMessage : false;
});
const isBundle = computed(() => {
  return props.tags.includes('Product Bundle');
});

const swdEligible = computed(() => {
  return props.tags.includes('Discount Codes: Allow');
});

const isTiered = computed(() => {
  const tags = props?.promo?.tiers?.tags?.split(',');
  const tieredEligible = tags
    ? tags?.filter((tag) => {
        return props.tags.includes(tag);
      })?.length == tags.length
    : false;
  const isEnabled = props?.promo?.tiers?.enabled ?? false;
  return tieredEligible && isEnabled;
});

const tieredPillMessage = computed(() => {
  return isTiered.value ? 'Buy more, save more' : '';
});
const containsBundleDiscount = computed(() => !props.tags.includes('Product Bundle No Discount'));

const containsCategoryDiscount = computed(() => {
  const containsTag = props.tags.filter((tag) => tag.includes('Category Promo:')).length > 0;

  const isEnabled = props?.promo?.category?.enabled ?? false;
  return containsTag && isEnabled;
});

const isLastCall = computed(() => props.tags.includes('Last Call Assortment'));

const discountAmount = computed(() => {
  const defaultDiscount = isBundle.value ? 25 : 0;
  const hasDiscount = props.tags.filter((tag) => tag.includes('Discount Amount')).length > 0;

  const amount = hasDiscount ? parseTag(props.tags, 'Discount Amount') : defaultDiscount;

  return parseInt(amount);
});

const categoryDiscount = computed(() => {
  const hasDiscount = containsBundleDiscount.value;
  const amount = hasDiscount ? parseTag(props.tags, 'Category Promo:') : 0;
  return parseInt(amount);
});

const siteWideDiscount = computed(() => {
  if (swdEligible.value) {
    const amount = props?.promo?.swd?.amount ?? 0;
    return amount;
  } else {
    return 0;
  }
});

const promotedOptionGroups = computed(() => {
  const selections = props?.promotedOptionGroups?.selections ?? [];
  const groups = props?.promotedOptionGroups?.groups ?? [];

  const index = groups.findIndex((group) => group.values.find((value) => selections.includes(value)));

  if (index > -1) {
    const group = groups[index];
    const pill = group?.pill ?? false;
    if (!pill) return false;
    return pill.value;
  } else {
    return false;
  }
});

const pills = computed(() => {
  const values = [];
  const eligibleBundle = containsBundleDiscount.value && isBundle.value;
  let tieredPromotionMessage = isTiered.value ? '+ buy more, save more' : '';
  if (promotedOptionGroups.value) {
    values.push(promotedOptionGroups.value);
  }

  if (isLastCall.value && discountAmount.value > 0) {
    values.push(`Final sale ${discountAmount.value}% off ${tieredPromotionMessage}`);
  }

  if (eligibleBundle && discountAmount.value > 0) {
    values.push(`${discountAmount.value}% off bundle ${tieredPromotionMessage}`);
  }

  if (containsCategoryDiscount.value && categoryDiscount.value > 0) {
    values.push(`${categoryDiscount.value}% ${props.promo.category.msg}`);
  }

  if (swdEligible.value && siteWideDiscount.value > 0 && !isTiered.value) {
    const promo = props?.promo?.swd ?? false;
    const defaultMessage = 'off';
    const message = promo?.pillMsg !== '' ? promo?.pillMsg ?? defaultMessage : defaultMessage;
    values.push(`${siteWideDiscount.value}% ${message}`);
  }
  return values;
});

const isVisibile = computed(() => {
  const location = props?.location ?? '';
  let visible = true;
  if (location === 'auto-bundle' || location === 'cart' || location === 'auto-bundle-modal' || location === 'upsell' || location === 'stepped-review-component' || location === 'subtotal') {
    visible = false;
  }
  return visible && props.ready;
});
</script>
